(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateConcertOrBookingController', CreateConcertOrBookingController);

    CreateConcertOrBookingController.$inject = ['$http', '$rootScope', '$state'];

    function CreateConcertOrBookingController($http, $rootScope, $state) {
        var vm = this;
        vm.close = close;
        vm.createConcert = createConcert;
        vm.createBooking = createBooking;

        function close() {
            $rootScope.no_scroll = false;
            vm.show = false;
        }

        function createConcert() {
            $state.go('create_concert', {band_slug: vm.band_slug});
        }

        function createBooking() {
            $rootScope.no_scroll = false;
            $state.go('create_booking', {band_slug: vm.band_slug, backToStateName: 'musician', backToStateParams: {band_slug: vm.band_slug}});
        }
    }
})();